<template>
  <div>
    <search-catalytic-converters-banner></search-catalytic-converters-banner>
    <v-container>
      <v-dialog
        v-model="convertersIsLoading"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            Loading...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <error-alert :message.sync="convertersError"></error-alert>
      <v-alert
        v-if="!selectedCode && !selectedManufacturer && !selectedEngineSize"
        class="mt-10"
        outlined
        type="info"
        text
      >
        Search is empty! Please select an option from the menu
      </v-alert>
      <v-alert
        v-if="selectedEngineSize && vehicleNotes"
        class=""
        outlined
        type="info"
        text
      >
        NOTES: {{vehicleNotes}}
      </v-alert>
      <v-row v-show="!convertersIsLoading">
        <v-col
          v-for="converter in converters"
          :key="converter.id"
          sm="12"
          md="6"
          xl="4"
        >
          <!-- <v-card
            hover
            @click="$router.push('/show-catalytic-converter/' + converter.id)"
            max-width="550"
            class="rounded-lg px-8 py-1 ma-auto"
          >
            <div class=" py-3 d-flex">
              <div class="flex-grow-1">
                <p class="text-body-1">
                  Code/Grade: {{ converter.code }}
                </p>
                <p class="text-body-1">
                  Manufacturer: {{ converter.manufacturer }}
                </p>
                <p class="text-body-1">
                  Live Market Price: {{ converter.currentPrice ? '$' + converter.currentPrice : "Unavailable" }}
                </p>
              </div>
              <div>
                <v-img
                  lazy-src="/images/not-available.png"
                  :src="converter.image ? converter.image : '/images/not-available.png'"
                  width="130"
                  height="130"
                ></v-img>
              </div>
            </div>
          </v-card> -->
          <v-card
            hover
            @click="$router.push({name:'single-converter', params: {id: converter.id}})"
            max-width="480"
            class="rounded-xl d-flex px-3 flex-column ma-auto"
          >
            <v-img
              lazy-src="/images/not-available.png"
              :src="converter.image ? converter.image : '/images/not-available.png'"
              height="150"
            ></v-img>
            <v-card-text class="d-flex my-2 flex-column">
              <span class="pb-2 font-weight-black text-h6">{{ converter.code }}</span>
              <span class="pb-2 text-body-1 black--text">Manufacturer: {{ converter.manufacturer }}</span>
              <span v-if="converter.description" class="pb-2 text-body-2 black--text">Description: {{ converter.description }}</span>
              <!-- <span
                v-if="converter.current_price"
                class="pb-2 text-body-1 font-weight-bold black--text"
              >${{ converter.current_price }} </span> -->
            </v-card-text>
            <!-- <v-card-title>
              Code/Grade: {{ converter.code }}
            </v-card-title>
            <v-card-text>
              <div class="text-body-1">
                Manufacturer: {{ converter.manufacturer }}
              </div>
              <div class="text-body-1">
                Live Market Price: {{ converter.current_price ? '$' + converter.current_price : "Unavailable" }}
              </div>
            </v-card-text> -->
          </v-card>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
import { mapState } from "@/store/modules/searchCatalyticConverters";
import SearchCatalyticConvertersBanner from "./SearchCatalyticConvertersBanner.vue";

export default {
  components: { SearchCatalyticConvertersBanner },

  computed: {
    ...mapState({
      converters: (state) => state.data,
      convertersIsLoading: (state) => state.isLoading,
      convertersError: (state) => state.error,
      selectedCode: (state) => state.selectedCode,
      selectedManufacturer: (state) => state.selectedManufacturer,
      selectedEngineSize: (state) => state.selectedEngineSize,
      vehicleNotes: (state) => state.vehicleNotes,
    }),
  },
};
</script>
